export { default } from './TelephonyTabBar';
